import React from 'react';
import range from 'lodash/range';
import orderBy from 'lodash/orderBy';
import { Row, Col } from 'reactstrap';
import capitalize from 'lodash/capitalize';

import CollapseContainer from '../Review/CollapseContainer';

const calculateLodgeTotalPrice = lodges =>
  lodges.reduce((total, lodge) => total + Number(lodge.amount), 0);

const LodgesSummmary = ({ lodges }) => (
  <CollapseContainer
    title="Lodges"
    openCollapse={false}
    cost={calculateLodgeTotalPrice(lodges)}
  >
    {orderBy(lodges, ['itemData[day]']).map(lodge => (
      <Lodge key={lodge.id} {...lodge.itemData} />
    ))}
  </CollapseContainer>
);

export default LodgesSummmary;

type LodgeProps = {
  name: string,
  address: string,
  phoneNumbers: Array<String>,
  services: Array<String>,
};

type Trekker = {
  id: null | string,
  email: null | string,
  fullname: string,
};
type LodgeInvoiceDataProps = {
  bookingDate: string,
  checkinDate: string,
  checkoutDate: string,
  companyName: string,
  currency: string,
  groupLeader: string,
  groupLeaderId: string,
  groupName: string,
  id: string,
  lodge: LodgeProps,
  mealPlan: string,
  pax: number,
  payableAmount: string,
  paymentPlan: string,
  remainingAmount: string,
  roomType: string,
  totalAmount: string,
  trekker: Trekker,
  day: number,
  numberOfDays: number,
};

const constructDays = (day, numberOfDays) =>
  `Day ${range(day, day + numberOfDays).join(', ')}`;

const Lodge = ({
  lodge: { name, address, services },
  currency,
  day,
  totalAmount,
  numberOfDays,
}: LodgeInvoiceDataProps) => (
  <Row>
    <Col>
      <ul className="border-bottom">
        <li>
          <strong>{constructDays(day, numberOfDays)}</strong>
        </li>
        <li>
          <strong>
            {name}, {address}
          </strong>{' '}
          <span className="float-right">
            {currency} {Number(totalAmount).toLocaleString()}
          </span>
        </li>
        <li>{services && services.map(capitalize).join(', ')}</li>
      </ul>
    </Col>
  </Row>
);



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Payment/LodgesSummary.jsx